<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive" :can-cancel="true">
      <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">ロボを配置</span>
          </div>
        </header>
        <div class="card-content">
          <p class="desc-big">配置するロボを選んでください</p>
          <p class="desc-small" style="font-size: 12px; color: #666;">配置されたロボをクリックすると該当のロボが起動します</p>
          <div class="search-box">
            <input v-model="search" class="input is-small search" placeholder="🔍探したいロボを入力"/>
          </div>
          <div class="robo-box">
            <div class="robo-card" v-for="(c, i) in chatbots" :key="i" v-if="!search || c.name.indexOf(search) >= 0">
              <img class="img-icon" :src="c.icon_data" v-if="c.icon_data"/>
              <img class="img-icon" src="@/assets/template/robot.png" v-else/>
              <p class="name">{{c.name}}</p>
              <button class="button robo-setting" @click="selectRobot(c)">ロボを設置</button>
            </div>
          </div>
        </div>
        <button class="button is-fullwidth">キャンセル</button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ModalSelectRobots',
  computed: {
    ...mapState('chatbot', ['chatbots']),
    ...mapState('virtualOffice', ['roomStatus']),
  },
  data () {
    return {
      search: null,
      isCardModalActive: false,
    }
  },
  methods: {
    selectRobot (cb) {
      let roomStatusTemp = this.roomStatus
      roomStatusTemp.type = 'robot'
      roomStatusTemp.id = cb.bot_id
      this.$store.dispatch('virtualOffice/setVirtualOfficeSV', roomStatusTemp)
      this.isCardModalActive = false
    },
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.desc-big {
  font-size: 16px;
  font-weight: 600;
  text-align: left;
}
.desc-small {
  font-size: 13px;
  color: rgb(102, 102, 102);
  text-align: left;
}
.search-box {
  display: flex;
  margin-top: 8px;
}
.search {
  width: 320px;
}
.img-icon {
  height: 128px;
  width: 128px;
  object-fit: cover;
  border-radius: 50%;
  border: solid 2px #d55;
  background: white;
}
.name {
  width: 128px;
  text-align: center;
  font-weight: 600;
  margin-top: 4px;
}
.robo-setting {
  color: #d55;
  font-size: 14px;
  margin-top: 4px;
  border: none;
}
.robo-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 16px;
  height: calc(100vh - 320px);
  overflow: auto;
}
.robo-card {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/ModalSelectRobots.vue